module.exports = __webpack_public_path__ + "static/media/viewer.bce9c578.png";